// extracted by mini-css-extract-plugin
export default {"header":"_12eH","logoutLink":"tZvC","policyLink":"_2Y-t"};